import React from "react";
import { Box } from "../../../Box";
import { Flex } from "../../../Flex";
import { Label } from "../../../Label";
import { LoginButton } from "../../../LoginButton";
import { VectorLogo } from "../../../VectorLogo";
import { Image } from "../../../Image";
import { Link } from "../../../Link";
import Exit from "../../../../assets/images/exit.svg";

interface Props {
  showActionBar?: boolean;
  onClose: () => void;
  serviceCatalogueNav?: boolean;
}

export const MobileMenuHeader: React.FC<Props> = ({
  onClose,
  serviceCatalogueNav,
  showActionBar,
}) => (
  <Flex
    justifyContent="space-between"
    py={serviceCatalogueNav ? "0px" : 2}
    pt={serviceCatalogueNav ? "15px" : 0}
    pl={2}
    pr={3}
    alignItems={serviceCatalogueNav ? "flex-start" : "center"}
  >
    <Box
      height="auto"
      pt={serviceCatalogueNav ? 1 : 2}
      pl={serviceCatalogueNav ? "7px" : 1}
    >
      <Link href="https://www.vector.co.nz">
        <VectorLogo height={serviceCatalogueNav ? "unset" : 78} />
      </Link>
    </Box>
    <Flex alignItems="center" pt={1}>
      {showActionBar ? <LoginButton mx={2} /> : null}
      {serviceCatalogueNav ? (
        <Box mr="11px" mt="4px" onClick={onClose}>
          <Image src={Exit} alt="exit" />
        </Box>
      ) : (
        <Label
          fontSize={65}
          mr={2}
          width={25}
          fontWeight={300}
          color="white"
          onClick={onClose}
        >
          &times;
        </Label>
      )}
    </Flex>
  </Flex>
);

MobileMenuHeader.defaultProps = {
  showActionBar: true,
};
